import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { logoutAction } from "../../actions/LoginAction";
import { AssetStore } from "../../assets/AssetsStore";
import {
  C2MD_ANDROID_APP_LINK,
  C2MD_IOS_APP_LINK,
} from "../../constants/const";
import AppoinmentHistory from "../AppoinmentHistory/DoctorAppointmentHistory";
import Assets from "../Layout/Assets";
import TermsandConditions from "../TermsandConditions";
import DoctorDashboardComponent from "./Components/DoctorDasboardComponent/DoctorDashboardComponent";
import Prescription from "../../components/PrintPrescription/PrintPrescription";
import styles from "./dashboardv2.module.scss";
import { Nav, NavDropdown } from "react-bootstrap";
import PrintPrescription from "../../components/PrintPrescription/PrintPrescription";
import { createContext } from "react";
import DashboardNavbar from "../DashboardNavbar/DashboardNavbar";
import { DashboardNavIcon, NavIcons } from "../../assets/NavbarIcons/NavIcons";
import DashboardAvatar from "../DashboardAvatar/DashboardAvatar";
import { ThemeList, getTheme } from "../../config/theme.config";
import FaqContent from "../FAQ/FaqContent";


//Contexts...............................................

export const DrDashboardContext = createContext();

function DoctorDashboardV2() {
  const dashOptions = [
    { name: "Home" },
    { name: "My Appointments" },

    // { name: "My Health profile" },
    // { name: "My Doctors" },
    // { name: "My Health files" },
    { name: "Legal" },
    { name: "CREATE_PRESCRIPTION" },
  ];
  const navData = [
    {
      options: [
        {
          name: "Home",
          ico: <DashboardNavIcon />,
        },
      ],
    },
    {
      tittle: "MY APPOINTMENTS",
      options: [
        {
          name: "Booked Appointments",
          ico: NavIcons.BookedAppointmentNavIcon(),
        },
        // {
        //   name: "My Appointment Requests",
        //   ico: NavIcons.AppointmentRequestsNavIcon(),
        // },
      ],
    },

    {
      tittle: "Help",
      options: [
        {
          name: "FAQ",
          ico: NavIcons.Faq(),
        },
        {
          name: "Legal",
          ico: NavIcons.Privacy(),
        },
        // {
        //   isContact: true,
        //   href: "tel:+91 9876543210",
        //   name: "+91 9876543210",
        //   ico: AssetStore?.dashbaodrV2?.phone,
        // },
        // {
        //   isContact: true,
        //   href: "mailto:testemailbydeveloper@gmail.com",
        //   name: "testemailbydeveloper@gmail.com",
        //   ico: AssetStore?.dashbaodrV2?.mail,
        // },
      ],
    },
    // {
    //   options: [
    //     {
    //       name: "Prescription",
    //       ico: <DashboardNavIcon />,
    //     },
    //   ],
    // },
  ];
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const clientDetailsLocal = JSON.parse(localStorage.getItem("ClinicDetails"));

  //States..................................................

  const [activeNavItem, setActiveNavItem] = useState(() => dashOptions[0].name);
  const [activeCount, setActiveCount] = useState(1);
  const [drDashboardData, setDrDashboardData] = useState({});
 // const [signupData, setsignupData] = useState(location.state);

  const navContentRef = useRef();

  //Redux.....................................................

  let clientDetails = useSelector((state) => state.clientDetails);
  let signupData = location.state;
  console.log("signupData", signupData);
  console.log("signupData", location.state);
  //functions...........................................................

  useEffect(() => {
    console.log("useEffect is running");
    console.log("signupData:", signupData);
    if (signupData != undefined && signupData.appointmentId != undefined) {
      console.log("signupData is not undefined");
      if (signupData.page === "prescription") {
        console.log("signupData.page is prescription");
        setDrDashboardData({
          appointmentId: signupData.appointmentId,
        });
        setActiveNavItem("CREATE_PRESCRIPTION"); // Set the active nav item to "CREATE_PRESCRIPTION"
        goToCreatePrescription(); // Call the goToCreatePrescription function
      }
    } else {
      console.log("signupData is undefined or appointmentId is undefined");
      setActiveNavItem(dashOptions[0].name);
    }
  }, [signupData]);
  

 
  useEffect(() => {
    const parentDiv = navContentRef.current;
    parentDiv.scrollTop = 0;
  }, [activeNavItem]);


  function goToHistory() {
    setActiveNavItem(dashOptions[1]?.name);
    setActiveCount(0);
  }
  function goToPrescription() {
    setActiveNavItem(dashOptions[3]?.name);
    setActiveCount(0);
  }
  function handleLogout() {
    dispatch(logoutAction(userData, history));

    if (clientDetails && clientDetails.homeurl) {
      history.push("/signin");
      window.open(clientDetails.homeurl, "_blank");
    } else {
      history.push("/signin");
    }
  }
  function goToCreatePrescription() {
    setActiveNavItem("CREATE_PRESCRIPTION");
    
  }

  window.addEventListener('beforeunload', function(event) {
    // Handle the popstate event here, e.g., update the UI or revert to a previous state.
    console.log("browser refresh hit")
    history.push("/dashboard");
   
  });
  function handleHelpMenuClick({ option, value }) {
    switch (option) {
      case "email":
        window.location.href = `mailto:${value}`;
        break;
      case "phone":
        window.location.href = `tel:${value}`;
        break;
      case "faq":
        var url =
          window.location.protocol +
          "//" +
          window.location.host +
          process.env.PUBLIC_URL +
          "/faq";
        window.open(url, "_blank");
        break;
      default:
        break;
    }
  }

  function getActiveComponent() {
    console.log("activeNavItem",activeNavItem)
    switch (activeNavItem) {
    
      case "Home":
        return <DoctorDashboardComponent goToHistory={goToHistory} />;
      case "Booked Appointments":
        return (
          <AppoinmentHistory
            white={true}
            goToPrescription={goToPrescription}
            goToCreatePrescription={goToCreatePrescription}
          />
          
        );
        case "My Appointments":
        return (
          <AppoinmentHistory
            white={true}
            goToPrescription={goToPrescription}
            goToCreatePrescription={goToCreatePrescription}
          />
        );
      case "FAQ":
        return <FaqContent noHeader />;
      case "CREATE_PRESCRIPTION":
        return <PrintPrescription />;
      case "Legal":
        return <TermsandConditions noHeader typeId="terms" />;
      default:
        break;
    }
  }

  function getHeaderText() {
    switch (activeNavItem) {
      case "Home":
        return "My Dashboard";
      case "CREATE_PRESCRIPTION":
        return "Create/Edit Prescription";
      default:
        return activeNavItem;
    }
  }
  

  return (
    <DrDashboardContext.Provider
      value={{ drDashboardData, setDrDashboardData }}
    >
      <div className={styles.container}>
        <div className={styles.dashboard_header}>
          <img className={styles.logo} src="https://aravind.org/wp-content/themes/aravind/assets/images/footer-logo.png" alt="" />

          <h1 className={styles.dashboardTitle}>{getHeaderText()}</h1>

          <div className={styles.action_container}>
            <DashboardAvatar
              handleHelpMenuClick={handleHelpMenuClick}
              handleLogout={handleLogout}
            />
          </div>
        </div>

        <div className={styles.dashboard_body}>
          <div className={styles.navbar}>
            <DashboardNavbar
              isDoctor
              theme={getTheme(ThemeList.GANGA)}
              onItemClick={setActiveNavItem}
              activeNavItem={activeNavItem}
              navData={navData}
            />
          </div>
          <div className={styles.navbar_content} ref={navContentRef}>
            {/* {activeNavItem === dashOptions[0].name ? (
              <DoctorDashboardComponent goToHistory={goToHistory} />
            ) : activeNavItem === dashOptions[1].name ? (
              <AppoinmentHistory
                white={true}
                goToPrescription={goToPrescription}
                goToCreatePrescription={goToCreatePrescription}
              />
            ) : activeNavItem === dashOptions[2].name ? (
              <TermsandConditions noHeader />
            ) : activeNavItem === dashOptions[3].name ? (
              <Prescription noHeader />
            ) : activeNavItem === dashOptions[2].name ? (
              `Item ${dashOptions[2].name}`
            ) : activeNavItem === "CREATE_PRESCRIPTION" ? (
              <PrintPrescription />
            ) : null} */}
            {getActiveComponent()}
          </div>
        </div>
      </div>
    </DrDashboardContext.Provider>
  );
}

export default DoctorDashboardV2;
